import React from "react";
import styles from "./BottomNav.module.scss";

interface BottomNavProps {
  onShowQR: () => void;
}

const BottomNav: React.FC<BottomNavProps> = ({ onShowQR }) => (
  <nav className={styles.Nav}>
    <div className={styles.Bar}>
      <button
        className={styles.QRButton}
        onClick={onShowQR}
        type="button"
        aria-label="Show my QR code"
      >
        <svg
          width="26"
          height="26"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="3" width="7" height="7" rx="1" />
          <rect x="14" y="3" width="7" height="7" rx="1" />
          <rect x="3" y="14" width="7" height="7" rx="1" />
          <rect x="14" y="14" width="3" height="3" rx="0.5" />
          <rect x="18" y="14" width="3" height="3" rx="0.5" />
          <rect x="14" y="18" width="3" height="3" rx="0.5" />
          <rect x="18" y="18" width="3" height="3" rx="0.5" />
        </svg>
      </button>
    </div>
  </nav>
);

export default BottomNav;
